export function talkProbe(step: string): void {
  const safe = step.replace(/[^a-z0-9-]/gi, '').slice(0, 48)
  const base = import.meta.env.VITE_API_URL || ''
  void fetch(`${base}/api/v1/help/talk-probe/${safe}`, { credentials: 'include' }).catch(() => {})
}
